import { CLEAR_EXPORTED_CHART_PAYLOAD, GET_EXPORTED_CHART_PAYLOAD } from '../actions/chartExporting';
import { withFulFilled, withPending, withRejected } from './commons';

const INITIAL_STATE = {
  exportingConfig: {
    running: false,
    error: undefined,
    data: undefined,
  },
};

function getExportedChartPayloadWithPending(state) {
  return {
    ...state,
    exportingConfig: {
      running: true,
      error: undefined,
      data: undefined,
    },
  };
}

function getExportedChartPayloadWithFulFilled(state, action) {
  return {
    ...state,
    exportingConfig: {
      running: false,
      error: undefined,
      data: action.payload,
    },
  };
}

function getExportedChartPayloadWithRejected(state, action) {
  return {
    ...state,
    exportingConfig: {
      running: false,
      error: action.payload,
      data: undefined,
    },
  };
}

function clearExportedChartPayload(state) {
  return {
    ...state,
    exportingConfig: {
      running: false,
      error: undefined,
      data: undefined,
    },
  };
}

const execute = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		// Como ainda será implementado uma chamada ao serviço de processamento de imagem / exportação csv / xlsx
		// o primeiro case será sempre chamado, que é um update da store do redux sem chamadas à api.

    // PNG CASE - Como não tem processamento do backend é feito uma chamada direta sem estado de promise.
		case GET_EXPORTED_CHART_PAYLOAD:
      return getExportedChartPayloadWithFulFilled(state, action);
    // CSV | XLSX cases
    case withPending(GET_EXPORTED_CHART_PAYLOAD):
			return getExportedChartPayloadWithPending(state);
		case withFulFilled(GET_EXPORTED_CHART_PAYLOAD):
			return getExportedChartPayloadWithFulFilled(state, action);
		case withRejected(GET_EXPORTED_CHART_PAYLOAD):
			return getExportedChartPayloadWithRejected(state, action);
		case CLEAR_EXPORTED_CHART_PAYLOAD:
			return clearExportedChartPayload(state);
		default:
			return state;
	}
}

export default execute;
